var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPopular = function SvgPopular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Popular_svg__a)",
    d: "M11.516 6.855q-.226.364-.538.712a1.14 1.14 0 0 1-.797.381 1.15 1.15 0 0 1-1.132-.717 1.16 1.16 0 0 1-.083-.51c.047-.741-.194-1.612-.716-2.59-.264-.49-.58-.91-.956-1.256a3.8 3.8 0 0 1-.19.727 5.5 5.5 0 0 1-.909 1.578q-.406.497-.915.887a4.4 4.4 0 0 0-1.263 1.53 4.3 4.3 0 0 0-.454 1.937c0 1.17.46 2.27 1.296 3.1A4.43 4.43 0 0 0 8 13.922a4.43 4.43 0 0 0 3.14-1.288 4.34 4.34 0 0 0 1.297-3.1c0-.612-.126-1.207-.374-1.767a4.3 4.3 0 0 0-.547-.912"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Popular_svg__b)",
    d: "M13.033 7.334a5.4 5.4 0 0 0-1.295-1.8l-.455-.417a.126.126 0 0 0-.203.052l-.203.583c-.127.365-.36.739-.69 1.106a.1.1 0 0 1-.064.031.09.09 0 0 1-.067-.023.1.1 0 0 1-.031-.075c.058-.941-.223-2.002-.84-3.157-.508-.959-1.216-1.707-2.1-2.23l-.646-.379a.125.125 0 0 0-.187.114l.034.75c.023.513-.036.966-.177 1.342-.171.461-.418.89-.734 1.274q-.331.401-.742.72a5.5 5.5 0 0 0-1.567 1.898 5.43 5.43 0 0 0-.133 4.536 5.49 5.49 0 0 0 2.928 2.9A5.5 5.5 0 0 0 8 14.988c.742 0 1.46-.144 2.14-.427a5.45 5.45 0 0 0 1.747-1.167A5.4 5.4 0 0 0 13.5 9.536c0-.763-.156-1.503-.467-2.202m-1.892 5.302A4.43 4.43 0 0 1 8 13.923a4.43 4.43 0 0 1-3.14-1.287 4.34 4.34 0 0 1-1.298-3.1c0-.68.154-1.331.455-1.938a4.4 4.4 0 0 1 1.263-1.53c.338-.258.646-.556.915-.887.39-.476.697-1.008.91-1.578a3.8 3.8 0 0 0 .189-.726c.376.346.692.765.956 1.256.522.978.762 1.848.716 2.589a1.156 1.156 0 0 0 2.012.847q.313-.349.538-.713.328.42.547.913a4.3 4.3 0 0 1 .374 1.767c0 1.17-.46 2.272-1.296 3.1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Popular_svg__a",
    x1: 3.563,
    x2: 12.438,
    y1: 8.398,
    y2: 8.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF475D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0F23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Popular_svg__b",
    x1: 8,
    x2: 8,
    y1: 1.008,
    y2: 14.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB78A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3449"
  })))));
};
export default SvgPopular;